<template>
  <FormInputWrapper>
    <FormTextInput v-bind="inputProps" @update:modelValue="$emit('update:modelValue', $event)" />
  </FormInputWrapper>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import { computed, useAttrs } from 'vue'
import pick from 'lodash/pick'
import { FormTextInput } from '@aryeo/runway'

import FormInputWrapper from '@/Runway/Forms/FormInputs/FormInputWrapper.vue'

const attrs = useAttrs()

const props = defineProps({})

const inputProps = computed(() => {
  return {
    ...pick(props, Object.keys(FormTextInput.props)),
    ...attrs,
  }
})
</script>
